import {createGlobalStyle} from "styled-components";
import gridBootstrap from "./grid-bootstrap";
import lato from "@/styles/fonts/lato"
import themes from "@/styles/themes";

const GlobalStyle = createGlobalStyle`
  ${gridBootstrap}
  ${lato}
  * {
    font-family: 'Lato', 'sans-serif';
    font-weight: 400;
  }

  body {
    background-color: #f2f2f2;
    &.block-height{
      height: 100vh;
      width: 100vw;
      overflow: hidden;
    }
  }

  a {
    color: ${themes.estadao};
    text-decoration: none;
  }

  .text--center {
    text-align: center;
  }

  .text--right {
    text-align: right;
  }

  .forget-password {
    margin-bottom: 12px;
    font-size: 13px !important;
  }

  .recaptcha-box {
    margin: 5px 0;
    display: flex;
    justify-content: center;
    min-height: 80px;
    align-items: center;
  }
  .debug-menu{
    background: white;
    width: 450px;
    padding: 20px;
    margin: 0;
    font-size: 15px;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;

    div.area {
      height: 100%;
      overflow-y: scroll;
      border: none;
      padding: 0;
      width: auto;
      overflow-x: hidden;
    }

    h1 {
      color: ${themes.estadaoDark};
      font-weight: 700;
      font-size: 15px;
      margin: 0;
    }

    div.col-md-6 {
      margin: 10px 0;
      border: 1px solid ${themes.estadaoDark};
    }

    span {
      color: ${themes.estadaoDark};
      font-weight: 700;
      display: block;
      text-transform: uppercase;
    }
  }
`;

export default GlobalStyle;